import { createAction } from '@reduxjs/toolkit';

export const requestCreateComment = createAction('request/createComment');
export const requestViewComments = createAction('request/viewComments');
export const requestDeleteComment = createAction('request/deleteComment');
